import { render } from "./StandardAllTaxonomyFormT.vue?vue&type=template&id=d67ff3a4"
import script from "./StandardAllTaxonomyFormT.vue?vue&type=script&lang=js"
export * from "./StandardAllTaxonomyFormT.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__